// utils/userId.js
export function getOrCreateUserId() {
  let userId = localStorage.getItem('userId');
  if (!userId) {
    userId = crypto.randomUUID();// 'u_' + Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem('userId', userId);
  }
  return userId;
}
